import React from "react";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    waveLetter: {
        display: "inline-block",
        animation: `jump 500ms ease-out both`,
        animationDelay: `${ 10 * 30}ms`,
        transformOrigin: "50% 100%",
    },
}));


export default function WaveTitle({ text, triggerKey }) {
    const classes = useStyles();
    return (
        <span key={triggerKey} style={{
            whiteSpace: "pre-wrap",
            color: "#20667b",
            fontWeight: "bold",
        }}>
            {Array.from(text).map((ch, i) => (
                <span
                    key={i}
                    className={classes.waveLetter}
                    style={{
                        display: "inline-block",
                        animation: `jump 500ms ease-out both`,
                        animationDelay: `${i * 30}ms`,
                        transformOrigin: "50% 100%",
                    }}
                >
                    {ch}
                </span>
            ))}
            <style>{`
    @keyframes jump {
    0% { transform: translateY(0); }
    15% { transform: translateY(-0.35em); }
    35% { transform: translateY(0); }
    55% { transform: translateY(-0.15em); }
    75%, 100% { transform: translateY(0); }
    }
    `}</style>
        </span>
    );
}